import useBreakpoints from './useBreakPoints';

export default useBreakpoints;
